import classNames from 'classnames';
import React from 'react';

interface AssetGlyphProps {
  src: string;
  className?: string;
}

export default function AssetGlyph({ src, className }: AssetGlyphProps) {
  return (
    <span
      aria-hidden="true"
      className={classNames('block shrink-0 bg-current', className)}
      style={{
        maskImage: `url("${src}")`,
        WebkitMaskImage: `url("${src}")`,
        maskSize: '100% 100%',
        WebkitMaskSize: '100% 100%',
        maskRepeat: 'no-repeat',
        WebkitMaskRepeat: 'no-repeat',
      }}
    />
  );
}
